import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index"
import VueI18n from "vue-i18n";
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || "zh",
  messages: {
    "en": require("../../../../../lang/en"),
    "zh": require("../../../../../lang/zh"),
  },
});

export default {
    props: ["bindDriver"],
    data() {
        return {
            activeName: 'first',
            activeSelect: 'first',
            dayLoading: false,
            dayOption: {},
            orgId: '',
            isValue: true,
            isDisplay: true,
            driverNum: '',
            height: '500',
            list: [],
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true,
                serialNumber: true,
            },
            columnsAll: [
                {
                    prop: "driverNum",
                    label: this.$t('DriverAnalysis.driverNum'),
                    align: "center",
                },
                {
                    prop: "name",
                    label: this.$t('DriverAnalysis.name'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('DriverAnalysis.orgName'),
                    align: "center",
                },
                {
                    prop: "workTime",
                    label: this.$t('DriverAnalysis.workHour'),
                    align: "center",
                },
                {
                    prop: "useTimeRate",
                    label: this.$t('DriverAnalysis.useTimeRate'),
                    align: "center",
                }
            ],
            columnsOne: [
                {
                    prop: "carId",
                    label: this.$t('DriverAnalysis.carId'),
                    align: "center",
                },
                {
                    prop: "terminalId",
                    label: this.$t('DriverAnalysis.terminalId'),
                    align: "center",
                },
                {
                    prop: "driverNum",
                    label: this.$t('DriverAnalysis.driverNum'),
                    align: "center",
                },
                {
                    prop: "driverName",
                    label: this.$t('DriverAnalysis.driverName'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('DriverAnalysis.orgName'),
                    align: "center",
                },
                {
                    prop: "startTime",
                    label: this.$t('DriverAnalysis.startTime'),
                    align: "center",
                },
                {
                    prop: "endTime",
                    label: this.$t('DriverAnalysis.endTime'),
                    align: "center",
                },
                {
                    prop: "workTime",
                    label: this.$t('DriverAnalysis.workHour'),
                    align: "center",
                },
            ],
            columns: [],
            operates: {
                width: 100,
                fixed: "right",
                list: []
            },
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
            driveList: [],
            Columns: [
                {
                    prop: "carId",
                    label: this.$t('DriverAnalysis.carId'),
                    align: "center",
                },
                {
                    prop: "terminalId",
                    label: this.$t('DriverAnalysis.terminalId'),
                    align: "center",
                },
                {
                    prop: "driverNum",
                    label: this.$t('DriverAnalysis.driverNum'),
                    align: "center",
                },
                {
                    prop: "driverName",
                    label: this.$t('DriverAnalysis.driverName'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('DriverAnalysis.orgName'),
                    align: "center",
                },
                {
                    prop: "startTime",
                    label: this.$t('DriverAnalysis.startTime'),
                    align: "center",
                },
                {
                    prop: "endTime",
                    label: this.$t('DriverAnalysis.endTime'),
                    align: "center",
                },
                {
                    prop: "workTime",
                    label: this.$t('DriverAnalysis.workHour'),
                    align: "center",
                },
            ],
            currentDrivePage: 1, 
            pageDriveSize: 10, 
            DriveTotal: 1, 
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    methods: {
        initQuery(type) {
            this.type = type
            this.pageSize = 10
            this.currentPage = 1
            if (type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
        handleClick(event) {
            this.activeSelect = event.name
            if (this.activeSelect == 'first') {
                this.$nextTick(() => {
                    this.getDayUseRate()
                })
            } else {
                this.$nextTick(() => {
                    this.getDayUseRate()
                })

            }
        },
        getDayUseRate() {
            this.dayLoading = true
            let Data = []
            let dayUse = []
            let dataShadow = []
            let workTime = []
            let timeType = ''
            if (this.activeSelect == 'first') {
                timeType = '24'
            } else {
                timeType = '8'
            }
            let param = {
                orgId: Number(this.orgId),
                driverNum: this.driverNum,
                timeType: timeType,
                selectType: 0,
            }
            this.$store.dispatch("DriverAnalysis/GET_SELECTDRIVERDAILYUSRRATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        res.data.data.map((item, index) => {
                            Data.push(item.date)
                            workTime.push(item.workTime)
                            dayUse.push({date: item.date, dayUse: item.dayUseRate})
                        })
                        this.DayUseRate(Data, dayUse, workTime)
                    }
                }
                this.dayLoading = false
            }).catch(err => {
                this.dayLoading = false
            })
        },
        DayUseRate(Data, dayUse, workTime) {
            let option = {
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    formatter: function (item) {
                        let DayUse = ''
                        dayUse.map((t, k) => {
                            if (item[0].name == t.date) {
                                DayUse = t.dayUse
                            }
                        })
                        return i18n.t('DriverAnalysis.date')+':' + item[0].name + '<br/>' + i18n.t('DriverAnalysis.workHour')+':' + item[0].value + 'h' + '<br/>' + i18n.t('DriverAnalysis.useRate')+':' + DayUse + '%'
                    },
                },
                legend: {
                    left: '10',
                    data: [this.$t('DriverAnalysis.userTime')],
                    itemWidth: 12, 
                    itemHeight: 12, 
                    textStyle: {
                        color: '#fff'
                    }
                },
                toolbox: {
                    right: '10',
                    feature: {
                        mark: { show: true },
                        dataView: { show: true, readOnly: false, backgroundColor: '#081831', textareaColor: '#081831', textColor: '#fff' },
                        magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                        restore: { show: true },
                        saveAsImage: { name: this.$t('DriverAnalysis.dailyCarHour'), show: true, backgroundColor: '#081831' }
                    },
                    iconStyle: {
                        color: '#fff'
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisTick: {
                        show: false
                    },
                    splitLine: { show: false },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',

                        }
                    },
                    data: Data
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '2%',
                    containLabel: true
                },
                yAxis: [{
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        formatter: '{value} ',
                        color: '#fff'
                    },
                    splitLine: {
                        show: true, lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                    min: 0,
                }],
                series: [
                    {
                        name: this.$t('DriverAnalysis.userTime'),
                        data: workTime,
                        type: 'bar',
                        barCategoryGap: '40%',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#fff'
                          },
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#1e89f8' },                   
                                        { offset: 1, color: '#4fa3fb' },                   
                                    ]
                                )
                            },
                        }
                    },
                ]
            }
            this.dayOption = option
        },
        handleChange(val) {
            this.activeName = val.name
            if (this.activeName == 'first') {
                this.$nextTick(() => {
                    this.initQuery('all')
                })
            } else {
                this.$nextTick(() => {
                    this.getOneMonthRecordList()
                })

            }
        },
        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 0,
            };
            this.$store.dispatch('DriverAnalysis/GET_SELECTDRIVERUSRRATEPAGE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        getOneMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 0,
                driverNum: this.driverNum
            };
            this.$store.dispatch('DriverAnalysis/GET_SELECTDRIVERUSRRATEPAGE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        downCar() {
            if (this.type == 'one') {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/useDate/uploadDriverTimePage?orgId=${this.orgId}&selectType=${0}&driverNum=${this.bindDriver}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/useDate/uploadDriverTimePage?orgId=${this.orgId}&selectType=${0}&driverNum=${this.bindDriver}`
                        location.href = url
                    }
                }
            } else {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/useDate/uploadDriverTimePage?orgId=${this.orgId}&selectType=${0}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/useDate/uploadDriverTimePage?orgId=${this.orgId}&selectType=${0}`
                        location.href = url
                    }
                }
            }
            
        },
        getOneMonthRecordList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentDrivePage,
                pageSize: this.pageDriveSize,
                selectType: 0,
            };
            this.$store.dispatch('DriverAnalysis/GET_SELECTDRIVERALLWORKRECORD', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.driveList = res.data.data.list
                        this.$refs.drivePage.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        handleSelection() {},
        changeSize(item) {
            console.log(item)
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            if (this.type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
        changeDriveSize(items){
            this.pageDriveSize = items.pageSize
            this.currentDrivePage = items.pageNum
            this.getOneMonthRecordList()
        },
        downRecord() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/uploadDriverWorkRecord?orgId=${this.orgId}&selectType=${0}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/uploadDriverWorkRecord?orgId=${this.orgId}&selectType=${0}`
                    location.href = url
                }
            }
        }
    }
}
